import React from "react";
import { Box, Tooltip, IconButton, useTheme } from "@mui/material";
import axios from "../../utils/axios.tsx";
import { conversationActions } from "../../store/conversation.tsx";
import { useDispatch } from "react-redux";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

interface FavouritePromptProps {
  children?: React.ReactNode;
  content: string;
  clicked: boolean;
  setClicked: React.Dispatch<React.SetStateAction<boolean>>;
}

const FavouritePrompt: React.FC<FavouritePromptProps> = ({
  content,
  clicked,
  setClicked,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleOnClick = async () => {
    await axios
      .post("/v1/favourite/", JSON.stringify({ text: content }))
      .then((response) => {
        dispatch(conversationActions.appendCustomActionResponse(response.data));
        setClicked(true);
      });
  };

  return (
    <Box>
      <Tooltip
        title={i18n._(
          msg({
            context: "Title of the button which marks the answer as favourite.",
            message: "Favourite",
          }),
        )}
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "0.9rem",
            },
          },
        }}
      >
        <span>
          <IconButton
            onClick={handleOnClick}
            size="small"
            disabled={clicked}
            aria-label="favourite"
          >
            {clicked ? (
              <FavoriteIcon
                fontSize="small"
                style={{ color: theme.palette.primary.main }}
              /> // Filled icon if clicked is true
            ) : (
              <FavoriteBorderOutlinedIcon fontSize="small" /> // Outlined icon otherwise
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default FavouritePrompt;
